import { requireField } from './validators';

export default class MedicalEvent {
  constructor(data = {}) {
    requireField(data.type, 'medical.type');
    requireField(data.severity, 'medical.severity');
    requireField(data.status, 'medical.status');
    requireField(data.date, 'medical.date');

    this.id = data.id || `med-${Math.random().toString(36).slice(2, 9)}`;
    this.category = data.category || 'Medical';
    this.type = data.type;
    this.severity = data.severity;
    this.status = data.status;
    this.description = data.description || '';
    this.date = data.date;
    this.assignedOwner = data.assignedOwner || '';
    this.reviewDate = data.reviewDate || null;
    this.escalationLevel = data.escalationLevel || 'L1';
    this.attachments = data.attachments || [];
    this.createdBy = data.createdBy || 'System';
    this.createdAt = data.createdAt || new Date().toISOString();
    this.updatedAt = data.updatedAt || this.createdAt;
    this.visibility = data.visibility || ['Admin', 'Manager', 'Staff'];
  }

  toJSON() {
    return { ...this };
  }
}
